module.exports = __webpack_public_path__ + "media/produktion-svarv.8c245b49.mp4";